// extracted by mini-css-extract-plugin
var _1 = "ControlBarPopOver-module__animateUploadProgressBarWidth--ds4zX";
var _2 = "ControlBarPopOver-module__animatedBackground--tmvxj";
var _3 = "ControlBarPopOver-module__arrowBg--kmx7g";
var _4 = "ControlBarPopOver-module__arrowStroke--ADVVg";
var _5 = "ControlBarPopOver-module__floatingContainer--nKP4z";
var _6 = "ControlBarPopOver-module__inner--I3xgx";
export { _1 as "animateUploadProgressBarWidth", _2 as "animatedBackground", _3 as "arrowBg", _4 as "arrowStroke", _5 as "floatingContainer", _6 as "inner" }
